// Component Registry Configuration
// Defines the default components available in the application
// Component IDs match folder names in kebab-case

export const DEFAULT_COMPONENTS = [];

// Backwards compatibility mappings (old ID -> new ID)
export const COMPONENT_ID_ALIASES = {
  // KPI aliases
  'attr-stats': 'lead-time-statistics',
  'edge-time-kpi': 'edge-duration',
  'histogram': 'lead-time-histogram',

  // OCEL aliases
  'count-missing-timestamps': 'missing-timestamps',
  'events-without-objects': 'missing-event-object-ref',
  'object-type-event-intensity': 'event-intensity-per-object-type',
  'activity-counts': 'activity-counts-tile',

  // Process aliases
  'activity-sequence-builder': 'pre-activity-selector',
  'variant-selector': 'variant-explorer',
  'variant-selector-extended': 'variant-explorer-extended',
  'process-graph': 'ocdfg-viewer',

  // Visualization aliases
  'timeline-metrics': 'timeline-diagram',
  'weekly-pattern': 'weekday-activity-count',
  'edge-card': 'edge-frequency',
  'object-count-by-activity-kpi': 'object-counts-by-selected-activities',
};

// Components that are rendered outside the grid
export const NON_GRID_COMPONENTS = ['root-cause-analysis'];

// Component ID to hide close button
export const STATIC_COMPONENTS = ['lead-time-statistics', 'lead-time-histogram'];

// Components that hide all controls (close, settings, refresh)
export const MINIMAL_CONTROL_COMPONENTS = [
  'date-deviation-kpi',
  'date-deviation-kpi-2',
  'date-deviation-kpi-3',
  'date-deviation-kpi-4',
  'liefertermintreue-kpi',
];
